var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"k-stat-card"},[_c('i',{staticClass:"k-stat-card__icon",class:_vm.icon}),_c('p',{staticClass:"k-stat-card__value"},[_vm._v(_vm._s(_vm.value))]),_c('p',{staticClass:"k-stat-card__title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }